/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
    object, string, bool, shape,
    func,
} from 'prop-types';
import { useHistory } from 'react-router';
import { compose } from 'recompose';
import { Button } from '@material-ui/core';
import { addCardIsleGiftCardToCart } from '../../../../state/ducks/Recipient/ducks/CardIsle/CardIsle-Actions';
import LoadCardIsleLib from '../../../components/vendors/CardIsle/LoadCardIsleLib';
import { cardIslePluginConfig } from '../../../../state/ducks/Checkout/ducks/Recipient/ducks/CardIsle/CardIsle-Helpers';
import withAsyncScript from '../../../../lib/scriptLoader';
import KlarnaCreditPromotionBadge from '../../../components/Checkout/KlarnaPaymentOnSiteMessage/KlarnaCreditPromotionBadge/KlarnaCreditPromotionBadge';
import { getBaseCode } from '../../tracking/product/dataLayerProductHelpers';

const { sdkURL } = cardIslePluginConfig;
const PDPCardIsleGiftCard = (props) => {
    const {
        classes,
        selectedSku,
        scriptLoaded,
        isScriptLoadSucceed,
        currentBrandPresentation,
        handleMiniCartModalClick,
        featureFlags,
    } = props;
    const cardIsleUUidAttribute = (selectedSku?.attributes || [])?.find((attr) => attr.name === 'fullfill_sku');
    const cardIsleUUID = cardIsleUUidAttribute?.values?.[0]?.value;
    const dispatch = useDispatch();
    const history = useHistory();

    const handleAddToCart = (cardIsleInfo) => {
        const giftCards = cardIsleInfo.gift_cards || [];

        const components = giftCards.map((giftCard) => ({
            brandCode: giftCard.brandCode,
            componentType: 'GIFTCARD',
            productCode: giftCard.sku, // for test:|| GCSKU,
            quantity: 1,
            attributes: [
                {
                    attributeName: 'thumbnail',
                    attributeValue: giftCard.imageSrc,
                },
                {
                    attributeName: 'amount',
                    attributeValue: giftCard.amount,
                },
                {
                    attributeName: 'text',
                    attributeValue: giftCard.brand,
                },
            ],
        }));

        const enableMiniCart = featureFlags['is-mini-cart-enabled'] || featureFlags['is-mini-cart-v2-enabled'];
        const standAloneCardData = {
            sku: getBaseCode(selectedSku?.id),
            brandCode: selectedSku?.brandId || '1012',
            greetingMessage: cardIsleInfo.card_text,
            greetingCardKey: cardIsleInfo.pickup_code,
            greetingCardImage: cardIsleInfo.card_image,
            greetingCardName: cardIsleInfo.card_name,
            greetingCardType: 'CI',
            greetingThumbNail: cardIsleInfo.card_thumbnail,
            components,
        };
        dispatch(addCardIsleGiftCardToCart(standAloneCardData, history, enableMiniCart, handleMiniCartModalClick));
        return true;
    };

    const cardIsleReceiveMessage = (event) => {
        // verify that message came from Card Isle
        if (event.origin !== 'https://cardisle.com') {
            return;
        }

        if (typeof event.data.status !== 'undefined' && typeof document !== 'undefined') {
            if (event.data.status === 'success') {
                handleAddToCart(event.data);
            }
        }
    };
    useEffect(() => {
        if (scriptLoaded && typeof window !== 'undefined' &&  window.initiate_card_isle_widget) {
            window.initiate_card_isle_widget(false, `https://cardisle.com/shop/#/personalize?card_uuid=${cardIsleUUID}`);
            if (window.addEventListener) {
                window.addEventListener('message', cardIsleReceiveMessage, false);
            } else if (window.attachEvent) {
                window.attachEvent('onmessage', cardIsleReceiveMessage);
            }
        }
        return () => {
            // Cleanup on unmount (equivalent to componentWillUnmount)
            if (typeof window !== 'undefined' && window.initiate_card_isle_widget) {
                if (window.removeEventListener) {
                    window.removeEventListener('message', cardIsleReceiveMessage, false);
                } else if (window.detachEvent) {
                    window.detachEvent('onmessage', cardIsleReceiveMessage);
                }
            }
        };
    }, [scriptLoaded]);

    if (scriptLoaded && isScriptLoadSucceed) {
        return (
            <>
                <LoadCardIsleLib />
                <Button
                    className={`card-isle-button ${classes.personalizationButton} ${classes.marginBottom} ${currentBrandPresentation === 'food' ? classes.personalizationButtonBackgroundFood : classes.personalizationButtonBackgroundFlowers}`}
                >
                    Personalize & Add To Cart
                </Button>
                <KlarnaCreditPromotionBadge
                    selectedSku={selectedSku}
                />
            </>
        );
    }
    return <></>;
};

PDPCardIsleGiftCard.propTypes = {
    classes: object.isRequired,
    selectedSku: shape({
        id: string,
    }),
    scriptLoaded: bool.isRequired,
    isScriptLoadSucceed: bool.isRequired,
    currentBrandPresentation: string,
    handleMiniCartModalClick: func,
    featureFlags: object,
};

PDPCardIsleGiftCard.defaultProps = {
    selectedSku: {},
    currentBrandPresentation: '',
    handleMiniCartModalClick: () => {},
    featureFlags: {},
};

export default compose(
    withAsyncScript(sdkURL),
)(PDPCardIsleGiftCard);
